module.exports = __webpack_public_path__ + "static/img/icon_staking_success.e644cced.png";